export const fincScale = (x: number) => {
  const power = Math.floor(Math.log10(x))
  return Math.pow(10, power)
}

export const nearestMultiple = (x: number) => {
  const scale = fincScale(x)
  return Math.round(x / scale) * scale
}

export function calculateTicks(min: number, max: number, desiredTicks: number) {
  const range = max - min
  const roughStep = range / desiredTicks
  const step = roughStep <= 1 ? 1 : roughStep <= 2 ? 2 : roughStep <= 5 ? 5 : roughStep <= 10 ? 10 : Math.ceil(roughStep / 10) * 10
  const ticks = []
  const start = Math.floor(min / step) * step
  const end = Math.ceil(max / step) * step
  for (let current = start; current <= end; current += step) {
    ticks.push(current)
  }
  return ticks
}

export const formatDateDDMMYY = (date: string): string => {
  const parsedDate = new Date(date)

  const day = parsedDate.getDate().toString().padStart(2, "0")
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0")
  const year = parsedDate.getFullYear()

  return `${day}.${month}.${year}`
}

export const formatRemainingTime = (targetDateString: string): string => {
  const now = new Date()
  const targetDate = new Date(targetDateString)

  const diffMs = targetDate.getTime() - now.getTime()

  if (diffMs <= 0) return "00д : 00ч : 00м" // Date is in the past

  const totalMinutes = Math.floor(diffMs / 1000 / 60)
  const days = Math.floor(totalMinutes / 1440) // 60 * 24 = 1440
  const hours = Math.floor((totalMinutes % 1440) / 60)
  const minutes = totalMinutes % 60

  const pad = (n: number) => n.toString().padStart(2, "0")

  return `${pad(days)}д : ${pad(hours)}ч : ${pad(minutes)}м`
}

export function cleanParams<T>(queryParams: Record<string, unknown>): T {
  return Object.fromEntries(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(queryParams).filter(([_, value]) => value != null)
  ) as T
}
